import emailjs from "emailjs-com";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import "./Contact.css";

function Contact() {
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 850) {
        setHeight(window.innerHeight);
      } else {
        setHeight("max-content");
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [data, setData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const onNameChange = (event) => {
    setData((previousState) => {
      return { ...previousState, name: event.target.value };
    });
    // console.log(data);
  };

  const onEmailChange = (event) => {
    setData((previousState) => {
      return { ...previousState, email: event.target.value };
    });
    // console.log(data);
  };

  const onSubjectChange = (event) => {
    setData((previousState) => {
      return { ...previousState, subject: event.target.value };
    });
    // console.log(data);
  };

  const onMessageChange = (event) => {
    setData((previousState) => {
      return { ...previousState, message: event.target.value };
    });
    // console.log(data);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const serviceId = "service_ccdcnz8";
    const templateId = "template_4mco4beIshan";
    const userId = "LkmQnioW2G00XCCVN";

    emailjs.send(serviceId, templateId, data, userId).then(
      (response) => {
        console.log("SUCCESS!", response.status, response.text);
        Swal.fire({
          position: "center",
          icon: "success",
          text: "Email sent successfully!",
          background: "#1F232E",
          color: "rgba(255, 255, 255, 0.699)",
          showConfirmButton: false,
          timer: 3500,
        });
        setData({
          name: "",
          email: "",
          subject: "",
          message: "",
        });
        event.target.reset();
      },
      (error) => {
        console.log("FAILED...", error);
        Swal.fire({
          position: "center",
          icon: "error",
          text: "Failed to send email. Please try again later.",
          background: "#1F232E",
          color: "rgba(255, 255, 255, 0.699)",
          showConfirmButton: false,
          timer: 3500,
        });
        setData({
          name: "",
          email: "",
          subject: "",
          message: "",
        });
        event.target.reset();
      }
    );
  };

  return (
    <>
      <div
        className="container-my contact-div"
        style={{
          position: "relative",
          paddingTop: "0px",
          backgroundColor: "#1f232e85",
          height: height,
        }}
      >
        <iframe
          src="https://maps.google.com/maps?q=matara&t=&z=13&ie=UTF8&iwloc=&output=embed"
          width="100%"
          height="100%"
          frameBorder="0"
          style={{ border: 0, position: "absolute", top: 0, left: 0 }}
          allowFullScreen=""
          aria-hidden="false"
          tabIndex="0"
          title="Google Maps"
        />

        <section
          id="contact"
          className="contact container rounded contact-section"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#313743",
            paddingBottom: "4rem",
            paddingLeft: "3rem",
            paddingRight: "3rem",
          }}
        >
          <div className="container" data-aos="fade-up">
            <div
              className="section-title"
              style={{ marginBottom: "1rem", marginTop: "4rem" }}
            >
              <h2>Contact Me</h2>
            </div>

            <div className="row mt-5">
              <div className="col-lg-4">
                <div className="info" style={{ backgroundColor: "#00000000" }}>
                  <div className="address">
                    <i className="fa fa-map-marker"></i>
                    <h4>Location:</h4>
                    <p>
                      12/P, Pahadahena, Wewaihalagoda, Kekanadura, Matara, Sri
                      Lanaka
                    </p>
                  </div>
                  <div className="email">
                    <i className="fa fa-envelope"></i>
                    <h4>Email:</h4>
                    <p>t.gunawardana864@gmail.com</p>
                  </div>
                  <div className="phone">
                    <i className="fa fa-phone"></i>
                    <h4>Call:</h4>
                    <p>+94 71 5751 121</p>
                  </div>
                </div>
              </div>

              <div className="col-lg-8 mt-5 mt-lg-0">
                <form
                  onSubmit={handleSubmit}
                  method="post"
                  role="form"
                  className="php-email-form"
                  style={{ backgroundColor: "#00000000" }}
                >
                  <div className="row">
                    <div className="col-md-6 form-group">
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        id="name"
                        placeholder="Your Name"
                        value={data.name}
                        onChange={onNameChange}
                        required
                      />
                    </div>
                    <div className="col-md-6 form-group mt-3 mt-md-0">
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        id="email"
                        placeholder="Your Email"
                        value={data.email}
                        onChange={onEmailChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group mt-3">
                    <input
                      type="text"
                      className="form-control"
                      name="subject"
                      id="subject"
                      placeholder="Subject"
                      value={data.subject}
                      onChange={onSubjectChange}
                      required
                    />
                  </div>
                  <div className="form-group mt-3">
                    <textarea
                      className="form-control"
                      name="message"
                      rows="5"
                      placeholder="Message"
                      value={data.message}
                      onChange={onMessageChange}
                      required
                    ></textarea>
                  </div>
                  <div className="my-3">
                    <div className="loading">Loading</div>
                    <div className="error-message"></div>
                    <div className="sent-message">
                      Your message has been sent. Thank you!
                    </div>
                  </div>
                  <div className="text-center send-btn">
                    <button type="submit">Send Message</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Contact;
